// collagenThreadsData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const collagenThreads: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Collagen Thread Lift | Face Lift, Tighten, & Revitalize Your Skin",
            "description": "Revitalize your skin with Collagen Thread Lift, a non-surgical face lift that tightens, firms, and smooths your skin for a youthful, refreshed appearance. Discover the transformative power of collagen threads for natural skin rejuvenation today.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/collagen-thread-lift/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Collagen Thread Lift | Face Lift, Tighten, & Revitalize Your Skin",
                "description": "Revitalize your skin with Collagen Thread Lift, a non-surgical face lift that tightens, firms, and smooths your skin for a youthful, refreshed appearance. Discover the transformative power of collagen threads for natural skin rejuvenation today.",
                "url": "https://elitebodyhome.com/services/collagen-thread-lift/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-16T13:59:14+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-109.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-109.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Collagen Thread",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Collagen Thread Lift | Face Lift, Tighten, & Revitalize Your Skin",
                "description": "Revitalize your skin with Collagen Thread Lift, a non-surgical face lift that tightens, firms, and smooths your skin for a youthful, refreshed appearance. Discover the transformative power of collagen threads for natural skin rejuvenation today.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-109.jpg"
            },
        },
        "breadcrumbs": ["Home", "Services", "Collagen Thread Lift"],
        "hero": {
            "title": "Lift & Rejuvenate Naturally with Collagen Thread Lift!",
            "subtitle": "",
            "description": "At Elite Body Home, Collagen Thread Lift brings together the latest technology with experience to restore youthful radiant skin. Our RESTORATIVE thread lift gently elevates and tightens lax skin, encouraging natural collagen formation to seal lasting, revitalising results. Naturally look firmer and smoother, feel and look like yourself and even more beautiful at Elite Body Home, it's about you, making you feel better and better."
        },
        "howItWorks": {
            "title": "Q-What is a Collagen Thread Lift?",
            "description": "A Collagen Thread Lift is a type of non-surgical cosmetic procedure that uses dissolvable threads (usually made of collagen or polydioxanone (PDO) to lift and tighten sagging skin. These threads are placed in tissue beneath the surface of the skin and assist in stimulating the body's natural collagen generators, enhancing skin flexibility and tightness. This can give patients a refreshed appearance without undergoing more invasive surgical corporals. The threads dissolve gradually over time, but the boost of collagen helps keep those results for months."
        },
        "procedureSteps": {
            "heading": "Process For Collagen Thread Lift Procedure",
            "para": "The Collagen Thread Lift procedure works by inserting dissolvable threads under the skin and lifts the sagging areas by tightening the skin. These threads are made of biocompatible materials, like polydioxanone (PDO), which dissolve on their own over time, but also induce collagen proliferation.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "A thorough consultation with the doctor to evaluate your skin, establish treatment goals, and describe the procedure.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Preparation",
                    "desc": "The area is cleaned and a topical anesthetic is applied to reduce any discomfort.",
                    "icon": "fa-solid fa-prescription-bottle-medical"
                },
                {
                    "title": "Thread Insertion",
                    "desc": "Collagen-stimulating threads are delicately implanted under the skin through a thin needle or cannula. These threads provide scaffolding to lift sagging skin.",
                    "icon": "fa-solid fa-thread"
                },
                {
                    "title": "Collagen Stimulation",
                    "desc": "The threads promote collagen production over the next period, providing natural rejuvenation of your skin and firmness.",
                    "icon": "fa-solid fa-dna"
                },
                {
                    "title": "Positioning & Lifting",
                    "desc": "The stitches are then delicately manipulated to elevate and smoothen the skin, sculpting better-defined contours.",
                    "icon": "fa-solid fa-arrow-up"
                },
                {
                    "title": "Completion",
                    "desc": "The threads dissolve slowly, resulting in firmer, more youthful-looking skin.",
                    "icon": "fa-solid fa-check"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Collagen Threads",
            "subheading": "",
            "para": "A Collagen Thread Lift offers numerous advantages beyond simply enhanced aesthetics. This method provides many benefits compared with traditional facelift surgery and other non-surgical therapies.",
            "items": [
                {
                    "title": "Stimulating the Production of Collagen",
                    "desc": "The threads provide a support structure, prompting the body to stimulate its own collagen production. Increased collagen can lead to improved skin elasticity, while potentially minimizing the appearance of fine lines and wrinkles.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "Lifting and Tightening",
                    "desc": "These threads can elevate sagging skin — especially in the cheeks, jawline and neck — for a more youthful appearance.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Natural collagen stimulation",
                    "desc": "These threads stimulate the skin to generate collagen and with time, result in enhanced skin elasticity and skin texture.",
                    "icon": "fa-solid fa-seedling"
                },
                {
                    "title": "Customizable treatment",
                    "desc": "The procedure can be customized based upon the treatment area, i.e. the cheeks, jowls, or neck, which means a more focused lift.",
                    "icon": "fa-solid fa-sliders"
                },
                {
                    "title": "Subtle, natural look",
                    "desc": "The results are natural and not overdone, allowing the integrity of your facial expressions to remain intact.",
                    "icon": "fa-solid fa-face-grin"
                },
                {
                    "title": "Long-lasting results",
                    "desc": "Results may last 12-18 months, but some patients may enjoy longer results due to increased collagen production.",
                    "icon": "fa-solid fa-hourglass-end"
                }
            ]
        },
        "eligibility": {
            "heading": "Who is a Candidate for Collagen Thread Lift?",
            "subheading": "",
            "para": "This type is great for mild to moderate levels of skin laxity and non-surgical appearance care. The average age of candidates is between 30 and 60 but can vary depending on the person's skin condition.",
            "items": [
                {
                    "title": "Mild sagging",
                    "desc": "Those with mild sagging or drooping skin, such as in the face, jawline and neck.",
                    "icon": "fa-solid fa-circle-check"
                },
                {
                    "title": "Non-surgical option",
                    "desc": "Those not ready for invasive surgery with facelifts.",
                    "icon": "fa-solid fa-scissors"
                },
                {
                    "title": "Quick recovery",
                    "desc": "People who want to get back fast and with little downtime.",
                    "icon": "fa-solid fa-bolt"
                }
            ]
        },
        "preparationTips": {
            "heading": "What You Can Expect Before a Collagen Thread Lift",
            "subheading": "",
            "para": "Prepping For A Collagen Thread Lift: The Essential Guide Your practitioner will provide full instructions prior to your procedure.",
            "items": [
                {
                    "title": "Avoid certain medications",
                    "desc": "All common blood thinners — like aspirin — and supplements that can increase bruising should be discontinued.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Limit alcohol and smoking",
                    "desc": "Treat yourself right by avoiding alcohol and smoking 24 hours prior to your treatment to help the healing process.",
                    "icon": "fa-solid fa-wine-bottle"
                },
                {
                    "title": "Stay hydrated",
                    "desc": "Be well-hydrated in the days before your procedure, as this helps with skin elasticity and healing.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Discuss your medical history",
                    "desc": "Be sure to inform your practitioner of any health issues or medications in advance.",
                    "icon": "fa-solid fa-file-medical"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "A Collagen Thread Lift has both immediate and long-term outcomes. Immediately after the procedure, clients will notice a lift and tightening in the treated areas. The effects become even more primal in the following weeks, as the skin naturally generates more collagen resulting in a renewed, youthful glow.",
            "items": [
                {
                    "title": "Immediate lift",
                    "desc": "Tightening sagging areas visible.",
                    "icon": "fa-solid fa-arrow-up"
                },
                {
                    "title": "Improved skin texture",
                    "desc": "Better collagen leads to firmer and smoother skin.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Gradual enhancement",
                    "desc": "Collagen product CHANGES in the skin over time with continued improvement in the firmness and elasticity of the skin.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "Long-lasting effects",
                    "desc": "Results usually last a year and a half, but maintenance treatments can help extend the results further.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "",
                    "desc": "",
                    "icon": "fa-solid fa-water"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "What areas can be treated with a Collagen Thread Lift?",
                    "answer": "Common areas treated include the cheeks, jawline, brow, neck, and under-eye region. This procedure can also be used to lift and contour specific areas such as the nose and eyebrows."
                },
                {
                    "question": "Is the procedure painful?",
                    "answer": "The procedure is relatively painless due to the use of local anesthesia. Patients typically report feeling some pressure or mild discomfort, but not significant pain."
                },
                {
                    "question": "How long do the results last?",
                    "answer": "Results from a Collagen Thread Lift can last between 12-18 months, depending on factors such as age, lifestyle, and skin type. Since the threads stimulate collagen production, the skin continues to improve even after the threads dissolve."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Common side effects include mild swelling, bruising, or tenderness in the treated area, which typically subsides within a few days. In rare cases, more serious complications such as infection or visible threads may occur, though these are uncommon."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banfsefsner-Image-scaled.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Before-Aftersdfsf-Service-Images-8.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/sfsfsfsfs-1.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/sfsfsfsfs-2.jpg"
            ],
            "introductionImage": ""
        },
        "product": {
            "id": 153,
            "title": "Collagen Thread Lift",
            "price": 235,
            "description": "Non-surgical skin rejuvenation treatment that lifts and tightens using collagen-stimulating threads. Achieve natural results with minimal downtime."
        }
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "خيوط الكولاجين لشد الوجه | رفع، شد، وتجديد البشرة",
            "description": "جدد بشرتك بخيوط الكولاجين لشد الوجه، إجراء غير جراحي لرفع، شد، وتنعيم البشرة للحصول على مظهر شبابي منتعش. اكتشف القوة التحويلية لخيوط الكولاجين لتجديد البشرة الطبيعي اليوم.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/collagen-thread-lift/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "خيوط الكولاجين لشد الوجه | رفع، شد، وتجديد البشرة",
                "description": "جدد بشرتك بخيوط الكولاجين لشد الوجه، إجراء غير جراحي لرفع، شد، وتنعيم البشرة للحصول على مظهر شبابي منتعش. اكتشف القوة التحويلية لخيوط الكولاجين لتجديد البشرة الطبيعي اليوم.",
                "url": "https://elitebodyhome.com/services/collagen-thread-lift/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-16T13:59:14+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-109.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-109.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "خيوط الكولاجين",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "خيوط الكولاجين لشد الوجه | رفع، شد، وتجديد البشرة",
                "description": "جدد بشرتك بخيوط الكولاجين لشد الوجه، إجراء غير جراحي لرفع، شد، وتنعيم البشرة للحصول على مظهر شبابي منتعش. اكتشف القوة التحويلية لخيوط الكولاجين لتجديد البشرة الطبيعي اليوم.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-109.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "خيوط الكولاجين لشد الوجه"],
        "hero": {
            "title": "ارفعي بشرتك واستعيدي نضارتها بشكل طبيعي مع خيوط الكولاجين لشد الوجه!",
            "subtitle": "",
            "description": "في ايليت بودي هوم، يجمع شد الوجه باستخدام خيوط الكولاجين بين أحدث التقنيات والخبرة لاستعادة البشرة الشابة المشرقة. تعمل خيوطنا المرممة على رفع وشد البشرة المترهلة بلطف، مع تحفيز إنتاج الكولاجين الطبيعي لتحقيق نتائج دائمة ومنعشة. احصلي على مظهر أكثر شبابًا ونعومة بشكل طبيعي، وشعورًا بالثقة والجمال في ايليت بودي هوم، حيث نركز عليكِ لجعلكِ تشعرين بالأفضل دائمًا."
        },
        "howItWorks": {
            "title": "س- ما هي خيوط الكولاجين لشد الوجه؟",
            "description": "شد الوجه بخيوط الكولاجين هو إجراء تجميلي غير جراحي يستخدم خيوطًا قابلة للذوبان (عادةً ما تكون مصنوعة من الكولاجين أو البوليديوكسانون PDO) لرفع وشد البشرة المترهلة. يتم إدخال هذه الخيوط في الأنسجة تحت سطح الجلد حيث تساعد في تحفيز إنتاج الكولاجين الطبيعي في الجسم، مما يعزز مرونة البشرة وشدها. يوفر هذا الإجراء للمرضى مظهرًا منتعشًا دون الحاجة إلى عمليات جراحية أكثر توغلاً. تذوب الخيوط تدريجيًا مع الوقت بينما يستمر تحفيز الكولاجين في الحفاظ على النتائج لعدة أشهر."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء شد الوجه بخيوط الكولاجين",
            "para": "يعمل إجراء شد الوجه بخيوط الكولاجين عن طريق إدخال خيوط قابلة للذوبان تحت الجلد لرفع المناطق المترهلة من خلال شد البشرة. تصنع هذه الخيوط من مواد متوافقة حيويًا مثل البوليديوكسانون (PDO) التي تذوب تلقائيًا مع الوقت بينما تحفز إنتاج الكولاجين.",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "استشارة شاملة مع الطبيب لتقييم بشرتك، تحديد أهداف العلاج وشرح الإجراء.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "التحضير",
                    "desc": "تنظيف المنطقة المعالجة وتطبيق مخدر موضعي لتقليل أي انزعاج.",
                    "icon": "fa-solid fa-prescription-bottle-medical"
                },
                {
                    "title": "إدخال الخيوط",
                    "desc": "يتم إدخال خيوط تحفيز الكولاجين برفق تحت الجلد باستخدام إبرة رفيعة أو قنية. توفر هذه الخيوط دعامة لرفع البشرة المترهلة.",
                    "icon": "fa-solid fa-thread"
                },
                {
                    "title": "تحفيز الكولاجين",
                    "desc": "تحفز الخيوط إنتاج الكولاجين خلال الفترة التالية، مما يوفر تجديدًا طبيعيًا للبشرة وزيادة في الليونة.",
                    "icon": "fa-solid fa-dna"
                },
                {
                    "title": "التوضيع والرفع",
                    "desc": "يتم تعديل الخيوط برفق لرفع البشرة وتنعيمها، مما يعطي ملامح أكثر تحديدًا.",
                    "icon": "fa-solid fa-arrow-up"
                },
                {
                    "title": "الانتهاء",
                    "desc": "تذوب الخيوط تدريجيًا تاركة بشرة أكثر تماسكًا وشبابًا.",
                    "icon": "fa-solid fa-check"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد خيوط الكولاجين",
            "subheading": "",
            "para": "يوفر شد الوجه بخيوط الكولاجين العديد من المزايا التي تتجاوز التحسينات الجمالية. توفر هذه الطريقة فوائد عديدة مقارنة بعمليات شد الوجه الجراحية التقليدية والعلاجات غير الجراحية الأخرى.",
            "items": [
                {
                    "title": "تحفيز إنتاج الكولاجين",
                    "desc": "توفر الخيوط بنية داعمة تحفز الجسم على زيادة إنتاج الكولاجين الطبيعي. يؤدي زيادة الكولاجين إلى تحسين مرونة البشرة مع تقليل ظهور الخطوط الدقيقة والتجاعيد.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "الرفع والشد",
                    "desc": "يمكن لهذه الخيوط رفع البشرة المترهلة - خاصة في منطقة الخدين وخط الفك والرقبة - للحصول على مظهر أكثر شبابًا.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "تحفيز الكولاجين الطبيعي",
                    "desc": "تحفز هذه الخيوط البشرة على إنتاج الكولاجين مما يؤدي مع الوقت إلى تحسن مرونة البشرة وملمسها.",
                    "icon": "fa-solid fa-seedling"
                },
                {
                    "title": "علاج قابل للتخصيص",
                    "desc": "يمكن تخصيص الإجراء حسب المنطقة المراد علاجها مثل الخدين أو اللغد أو الرقبة مما يوفر رفعًا أكثر دقة.",
                    "icon": "fa-solid fa-sliders"
                },
                {
                    "title": "مظهر طبيعي ودقيق",
                    "desc": "النتائج طبيعية وغير مبالغ فيها، مع الحفاظ على تعابير وجهك الطبيعية.",
                    "icon": "fa-solid fa-face-grin"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "قد تدوم النتائج من 12 إلى 18 شهرًا، وقد يستمر بعض المرضى في الاستمتاع بنتائج أطول بسبب زيادة إنتاج الكولاجين.",
                    "icon": "fa-solid fa-hourglass-end"
                }
            ]
        },
        "eligibility": {
            "heading": "من هو المرشح المناسب لشد الوجه بخيوط الكولاجين؟",
            "subheading": "",
            "para": "هذا الإجراء مثالي للأشخاص الذين يعانون من ترهل خفيف إلى متوسط في البشرة ويرغبون في تحسين مظهرهم دون جراحة. يتراوح عمر المرشحين عادة بين 30 و60 سنة ولكن قد يختلف حسب حالة البشرة.",
            "items": [
                {
                    "title": "ترهل خفيف",
                    "desc": "الأشخاص الذين يعانون من ترهل خفيف أو تدلي في الجلد، خاصة في الوجه وخط الفك والرقبة.",
                    "icon": "fa-solid fa-circle-check"
                },
                {
                    "title": "خيار غير جراحي",
                    "desc": "الأشخاص غير المستعدين للخضوع لجراحة شد الوجه.",
                    "icon": "fa-solid fa-scissors"
                },
                {
                    "title": "تعافي سريع",
                    "desc": "الأشخاص الذين يرغبون في العودة سريعًا لأنشطتهم اليومية مع فترة تعافي قصيرة.",
                    "icon": "fa-solid fa-bolt"
                }
            ]
        },
        "preparationTips": {
            "heading": "ما يمكن توقعه قبل إجراء شد الوجه بخيوط الكولاجين",
            "subheading": "",
            "para": "التحضير لشد الوجه بخيوط الكولاجين: الدليل الأساسي سيوفر لك الممارس تعليمات كاملة قبل الإجراء.",
            "items": [
                {
                    "title": "تجنب بعض الأدوية",
                    "desc": "يجب التوقف عن تناول مميعات الدم الشائعة مثل الأسبرين والمكملات التي قد تزيد من الكدمات.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "الحد من الكحول والتدخين",
                    "desc": "اعتني بنفسك بتجنب الكحول والتدخين قبل 24 ساعة من العلاج لتعزيز عملية الشفاء.",
                    "icon": "fa-solid fa-wine-bottle"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "احرص على شرب كميات كافية من الماء في الأيام السابقة للإجراء، حيث يساعد ذلك في مرونة البشرة والشفاء.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "مناقشة التاريخ الطبي",
                    "desc": "تأكد من إبلاغ الممارس بأية مشاكل صحية أو أدوية تتناولها مسبقًا.",
                    "icon": "fa-solid fa-file-medical"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يوفر شد الوجه بخيوط الكولاجين نتائج فورية وطويلة الأمد. بعد الإجراء مباشرة، سيُلاحظ العملاء رفعًا وشدًا في المناطق المعالجة. تصبح النتائج أكثر وضوحًا في الأسابيع التالية مع زيادة إنتاج الكولاجين الطبيعي في البشرة مما يعطي إشراقة شبابية متجددة.",
            "items": [
                {
                    "title": "رفع فوري",
                    "desc": "شد المناطق المترهلة مرئي على الفور.",
                    "icon": "fa-solid fa-arrow-up"
                },
                {
                    "title": "تحسن ملمس البشرة",
                    "desc": "زيادة الكولاجين تؤدي إلى بشرة أكثر تماسكًا ونعومة.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "تحسن تدريجي",
                    "desc": "يستمر إنتاج الكولاجين في البشرة مع الوقت مع استمرار تحسن تماسك البشرة ومرونتها.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "آثار طويلة الأمد",
                    "desc": "تدوم النتائج عادةً لمدة عام ونصف، ولكن يمكن أن تساعد جلسات المتابعة في إطالة النتائج.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "",
                    "desc": "",
                    "icon": "fa-solid fa-water"
                }
            ]
        },
        "faqData": {
            "heading": "أسئلة شائعة",
            "subheading": "",
            "items": [
                {
                    "question": "ما هي المناطق التي يمكن علاجها بخيوط الكولاجين؟",
                    "answer": "تشمل المناطق الشائعة للعلاج الخدين، خط الفك، الحاجبين، الرقبة، ومنطقة تحت العين. يمكن أيضًا استخدام هذا الإجراء لرفع وتحديد مناطق معينة مثل الأنف والحواجب."
                },
                {
                    "question": "هل الإجراء مؤلم؟",
                    "answer": "الإجراء غير مؤلم نسبيًا بسبب استخدام التخدير الموضعي. عادة ما يشعر المرضى ببعض الضغط أو الانزعاج البسيط، ولكن ليس بألم شديد."
                },
                {
                    "question": "كم تدوم النتائج؟",
                    "answer": "يمكن أن تدوم نتائج شد الوجه بخيوط الكولاجين من 12 إلى 18 شهرًا، اعتمادًا على عوامل مثل العمر، نمط الحياة، ونوع البشرة. بما أن الخيوط تحفز إنتاج الكولاجين، تستمر البشرة في التحسن حتى بعد ذوبان الخيوط."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "تشمل الآثار الجانبية الشائعة تورمًا خفيفًا، كدمات، أو ألمًا في المنطقة المعالجة، والتي تختفي عادةً خلال بضعة أيام. في حالات نادرة، قد تحدث مضاعفات أكثر خطورة مثل العدوى أو ظهور الخيوط، رغم أن هذه غير شائعة."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }

};
